import React from 'react';
import { Box, Skeleton } from '@mui/material';

export interface ICardSkeletonGridProps {
  count?: number;
  height?: number;
  cardClass?: string;
}

/** Skeleton grid that mirrors the shape of the loaded cards using MUI Skeleton. */
export const CardSkeletonGrid = ({ count = 4, height = 180, cardClass }: ICardSkeletonGridProps) => {
  return (
    <Box
      role="status"
      aria-label="Loading content"
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          md: 'repeat(2, 1fr)',
          lg: 'repeat(3, 1fr)',
        },
        gap: 3,
      }}
    >
      {[...Array(count)].map((_, index) => (
        <Skeleton
          key={index}
          variant="rounded"
          height={height}
          sx={{ borderRadius: '18px' }}
        />
      ))}
    </Box>
  );
};
